import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fb89ebf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "uk-modal-title" }, "Re-Run Queue", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " * Re-run will have a separate queue ID. ", -1))
const _hoisted_3 = { class: "dx-field uk-margin-medium-top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Options:", -1))
const _hoisted_5 = {
  key: 2,
  class: "uk-button uk-button-default uk-modal-close",
  type: "button"
}
const _hoisted_6 = { class: "uk-align-center" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "uk-align-center uk-text-center guid-button-queued"
}
const _hoisted_9 = {
  key: 0,
  class: "uk-align-center uk-text-bold uk-text-center"
}
const _hoisted_10 = {
  key: 1,
  class: "uk-align-center uk-text-bold uk-text-center"
}
const _hoisted_11 = {
  key: 0,
  class: "uk-align-center uk-text-center uk-text-bold"
}
const _hoisted_12 = {
  key: 1,
  class: "uk-align-center uk-text-center uk-text-bold"
}
const _hoisted_13 = {
  key: 0,
  class: "uk-align-center uk-text-center uk-text-bold"
}
const _hoisted_14 = {
  key: 1,
  class: "uk-align-center uk-text-center uk-text-bold"
}
const _hoisted_15 = {
  key: 0,
  class: "spinner"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uk-text-bold running-text" }, "Running", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "uk-align-center uk-text-center uk-text-warning uk-text-bold"
}
const _hoisted_19 = {
  key: 2,
  class: "uk-align-center uk-text-center uk-text-success uk-text-bold"
}
const _hoisted_20 = { class: "uk-text-bold uk-text-center uk-text-success" }
const _hoisted_21 = { class: "uk-text-bold uk-text-center" }
const _hoisted_22 = { class: "uk-text-bold uk-text-center" }
const _hoisted_23 = { class: "uk-text-bold uk-text-center" }
const _hoisted_24 = { class: "uk-text-bold uk-text-center" }
const _hoisted_25 = { class: "uk-text-bold uk-text-center uk-text-danger" }
const _hoisted_26 = { class: "uk-text-bold uk-text-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uk-text-bold uk-text-center" }, " Re-Run ", -1))
const _hoisted_28 = { class: "flex-container" }
const _hoisted_29 = { class: "uk-align-center" }
const _hoisted_30 = { class: "message" }
const _hoisted_31 = {
  key: 0,
  class: "uk-label-success uk-align-center uk-text-center"
}
const _hoisted_32 = {
  key: 1,
  class: "uk-label-danger uk-align-center uk-text-center"
}
const _hoisted_33 = {
  key: 0,
  class: "uk-align-center uk-text-center"
}
const _hoisted_34 = {
  key: 1,
  class: "uk-align-center uk-text-center"
}
const _hoisted_35 = {
  key: 0,
  class: "spinner uk-align-center"
}
const _hoisted_36 = { class: "flex-container" }
const _hoisted_37 = { class: "flex-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxRadioGroup = _resolveComponent("DxRadioGroup")!
  const _component_loader_component = _resolveComponent("loader-component")!
  const _component_default_dialog = _resolveComponent("default-dialog")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_sapn = _resolveComponent("sapn")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_default_dialog, {
        "is-visible": _ctx.isVisible,
        "should-expand": false,
        "onUpdate:isVisible": _ctx.visibilityChanged
      }, {
        title: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", null, "Queue: " + _toDisplayString(this.reRunGuid), 1)
        ]),
        default: _withCtx(() => [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _hoisted_4,
              _createVNode(_component_DxRadioGroup, {
                class: "uk-margin-small-top",
                items: _ctx.reRunOptions,
                value: _ctx.reRunOptionSelected,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reRunOptionSelected) = $event)),
                layout: "horizontal"
              }, null, 8, ["items", "value"])
            ])
          ])
        ]),
        buttons: _withCtx(() => [
          (_ctx.isRunning)
            ? (_openBlock(), _createBlock(_component_loader_component, {
                key: 0,
                class: "uk-margin-remove"
              }))
            : _createCommentVNode("", true),
          (!_ctx.isRunning)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "uk-button uk-button-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ReRunQueue && _ctx.ReRunQueue(...args))),
                type: "button"
              }, "Run"))
            : _createCommentVNode("", true),
          (!_ctx.isRunning)
            ? (_openBlock(), _createElementBlock("button", _hoisted_5, "Cancel"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-visible", "onUpdate:isVisible"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createVNode(_component_DxDataGrid, {
        class: "logs uk-align-center",
        "data-source": _ctx.queueDataSource,
        ref: _ctx.gridRefName2,
        "row-alternation-enabled": true,
        "show-borders": true,
        "column-auto-width": true,
        "allow-column-resizing": true,
        "on-cell-prepared": _ctx.onCellPrepared
      }, {
        queue: _withCtx(({data}) => [
          (data.value !== null)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: ($event: any) => (_ctx.getQueueDetailLogs(data.value)),
                class: "uk-align-center uk-text-center guid-button"
              }, _toDisplayString(data.value), 9, _hoisted_7))
            : _createCommentVNode("", true),
          (data.value === null)
            ? (_openBlock(), _createElementBlock("button", _hoisted_8, "Currently Queued "))
            : _createCommentVNode("", true)
        ]),
        number: _withCtx(({data}) => [
          _createVNode(_component_sapn, { class: "uk-align-center uk-text-center uk-text-bold" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(data.value), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        leftInQueue: _withCtx(({data}) => [
          (data.value !== null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(data.value) + " Left In Queue", 1))
            : _createCommentVNode("", true),
          (data.value === null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(data.data.numberOfTotalWorkbooks) + " Left In Queue", 1))
            : _createCommentVNode("", true)
        ]),
        dateTemplate: _withCtx(({data}) => [
          (data.value !== null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.formatDate(data.value)), 1))
            : _createCommentVNode("", true),
          (data.value === null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Waiting..."))
            : _createCommentVNode("", true)
        ]),
        timeTemplate: _withCtx(({data}) => [
          (data.value !== null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.formatTime(data.value)), 1))
            : _createCommentVNode("", true),
          (data.value === null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Waiting..."))
            : _createCommentVNode("", true)
        ]),
        running: _withCtx(({data}) => [
          (data.value === true)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _hoisted_17))
            : _createCommentVNode("", true),
          (data.value === null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'pause'] }),
                _createTextVNode(" Queued")
              ]))
            : _createCommentVNode("", true),
          (data.value === false)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'check'] }),
                _createTextVNode(" Done")
              ]))
            : _createCommentVNode("", true)
        ]),
        "re-run-template": _withCtx(({data}) => [
          _createElementVNode("div", null, [
            _createVNode(_component_DxButton, {
              class: "uk-align-center",
              width: 80,
              type: "default",
              disabled: data.data.queueId === null || data.data.isCurrentlyRunning,
              icon: "play",
              "styling-mode": "outlined",
              onClick: ($event: any) => (_ctx.showModal(data))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'redo'] })
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"])
          ])
        ]),
        "successful-header": _withCtx(({data}) => [
          _createElementVNode("span", _hoisted_20, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'check'] }),
            _createTextVNode(" " + _toDisplayString(data.column.caption), 1)
          ])
        ]),
        "book-header": _withCtx(({data}) => [
          _createElementVNode("span", _hoisted_21, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'book'] }),
            _createTextVNode(" " + _toDisplayString(data.column.caption), 1)
          ])
        ]),
        "date-header": _withCtx(({data}) => [
          _createElementVNode("span", _hoisted_22, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'calendar'] }),
            _createTextVNode(" " + _toDisplayString(data.column.caption), 1)
          ])
        ]),
        "time-header": _withCtx(({data}) => [
          _createElementVNode("span", _hoisted_23, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'clock'] }),
            _createTextVNode(" " + _toDisplayString(data.column.caption), 1)
          ])
        ]),
        "warehouse-header": _withCtx(({data}) => [
          _createElementVNode("span", _hoisted_24, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'warehouse'] }),
            _createTextVNode(" " + _toDisplayString(data.column.caption), 1)
          ])
        ]),
        "failed-header": _withCtx(({data}) => [
          _createElementVNode("span", _hoisted_25, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'exclamation-triangle'] }),
            _createTextVNode(" " + _toDisplayString(data.column.caption), 1)
          ])
        ]),
        "normal-header": _withCtx(({data}) => [
          _createElementVNode("span", _hoisted_26, _toDisplayString(data.column.caption), 1)
        ]),
        "rerun-header": _withCtx(({}) => [
          _hoisted_27
        ]),
        add: _withCtx(() => [
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_DxButton, {
              width: 170,
              hint: "Refresh",
              text: "Refresh",
              icon: "refresh",
              type: "default",
              "styling-mode": "contained",
              onClick: _ctx.refreshOverviewLogs
            }, null, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxScrolling, { mode: "virtual" }),
          _createVNode(_component_DxColumn, {
            "data-field": "isCurrentlyRunning",
            caption: "Status",
            "cell-template": "running",
            width: 110,
            "header-cell-template": "normal-header"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "runDate",
            caption: "Date",
            "cell-template": "dateTemplate",
            width: 110,
            "header-cell-template": "date-header"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "runTime",
            caption: "Time",
            "cell-template": "timeTemplate",
            width: 110,
            "header-cell-template": "time-header"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "queueId",
            caption: "Queue ID",
            "cell-template": "queue",
            width: 300,
            "header-cell-template": "normal-header"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "failed",
            caption: "Workbooks Failed",
            "cell-template": "number",
            width: 200,
            "header-cell-template": "failed-header"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "success",
            caption: "Workbooks Successful",
            "cell-template": "number",
            width: 200,
            "header-cell-template": "successful-header"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "numberOfTotalWorkbooks",
            caption: "Workbooks",
            "cell-template": "number",
            width: 200,
            "header-cell-template": "book-header"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "numberOfWarehouses",
            caption: "Warehouses",
            "cell-template": "number",
            width: 200,
            "header-cell-template": "warehouse-header"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "workbooksRemaining",
            caption: "Remaining",
            "cell-template": "leftInQueue",
            width: 140,
            "header-cell-template": "book-header"
          }),
          _createVNode(_component_DxColumn, {
            "cell-template": "re-run-template",
            width: 80,
            "header-cell-template": "rerun-header"
          }),
          _createVNode(_component_DxToolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_DxItem, {
                location: "after",
                template: "add"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data-source", "on-cell-prepared"]), [
        [_vShow, _ctx.selectedQueue === '']
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      (_ctx.selectedQueue !== '')
        ? (_openBlock(), _createBlock(_component_DxDataGrid, {
            key: 0,
            class: "logs uk-align-center",
            "data-source": _ctx.dataSource,
            ref: _ctx.gridRefName,
            "show-borders": true,
            "column-auto-width": true,
            "allow-column-resizing": true,
            "row-alternation-enabled": true
          }, {
            queueIdTemplate: _withCtx(({data}) => [
              _createElementVNode("span", null, _toDisplayString(data.value), 1)
            ]),
            messageTemplate: _withCtx(({data}) => [
              _createElementVNode("span", _hoisted_30, _toDisplayString(data.value), 1)
            ]),
            statusTemplate: _withCtx(({data}) => [
              (data.value === false)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Success"))
                : _createCommentVNode("", true),
              (data.value === true)
                ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Failed"))
                : _createCommentVNode("", true)
            ]),
            queue: _withCtx(({data}) => [
              (data.value !== null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(data.value) + " Left In Queue", 1))
                : _createCommentVNode("", true),
              (data.value === null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Queue Done"))
                : _createCommentVNode("", true)
            ]),
            dateTemplate: _withCtx(({data}) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(data.value)), 1)
            ]),
            running: _withCtx(({data}) => [
              (data.value === 'Currently Running')
                ? (_openBlock(), _createElementBlock("span", _hoisted_35))
                : _createCommentVNode("", true)
            ]),
            add: _withCtx(() => [
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_DxButton, {
                  width: 170,
                  hint: "Refresh",
                  text: "Refresh",
                  icon: "refresh",
                  type: "default",
                  "styling-mode": "contained",
                  onClick: _ctx.refreshLogs
                }, null, 8, ["onClick"])
              ])
            ]),
            back: _withCtx(() => [
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_DxButton, {
                  width: 120,
                  hint: "Back To Overview",
                  text: "Back",
                  icon: "arrowleft",
                  type: "primary",
                  "styling-mode": "contained",
                  onClick: _ctx.backToOverview
                }, null, 8, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxHeaderFilter, { visible: true }),
              _createVNode(_component_DxScrolling, { mode: "virtual" }),
              _createVNode(_component_DxColumn, {
                "data-field": "currentlyRunning",
                "data-type": "string",
                caption: "",
                "cell-template": "running",
                width: 30
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "status",
                "data-type": "string",
                caption: "Status",
                width: 125,
                "cell-template": "statusTemplate"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "queue",
                "data-type": "string",
                caption: "Queue ID",
                width: 300,
                "cell-template": "queueIdTemplate"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "runDate",
                "data-type": "string",
                caption: "Run Date",
                "cell-template": "dateTemplate",
                width: 90
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "warehouse",
                "data-type": "string",
                caption: "Warehouse",
                width: 205
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "tableauServer",
                "data-type": "string",
                caption: "Tableau Server",
                width: 205
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "workbook",
                "data-type": "string",
                caption: "Workbook",
                width: 330
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "message",
                "data-type": "string",
                caption: "Message",
                "cell-template": "messageTemplate",
                width: 450
              }),
              _createVNode(_component_DxToolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_DxItem, {
                    location: "after",
                    template: "add"
                  }),
                  _createVNode(_component_DxItem, {
                    location: "before",
                    template: "back"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data-source"]))
        : _createCommentVNode("", true)
    ])
  ]))
}